import React from "react";
import POAuditReport from "../../../common/reports/audit/poAuditReport";

const POAuditIndex = props => {
  return <POAuditReport collabType="Pharma Co" {...props} />;
};

export default POAuditIndex;
